'use strict';
class Device {
    constructor(installation, device) {
        this.outService = !device;
        this.installation = installation;
        Object.assign(this, device);
    }

    //#region is/has
    isOutService() {
        return this.outService || this.installation.isOutService();
    }

    isOn() {
        return this.e != '0';
    }

    isStanby() {
        return this.e == '2';
    }

    isModeHeat() {
        return this.installation.isModeHeat();
    }

    isModeAC() {
        return this.isOn() && ['0', '1', '4', '5'].includes(this.m);
    }

    isModeFloor() {
        return this.isOn() && ['2', '3', '4', '5'].includes(this.m);
    }

    hasFanMode() {
        return this.vv != '0';
    }

    hasTimer() {
        return this.tzv != '0';
    }
    //#endregion

    //#region allow
    allowAC() {
        return this.allowHeat() || this.allowCool();
    }

    allowHeat() {
        return this.c == '1';
    }

    allowCool() {
        return this.f == '1';
    }

    allowFan() {
        return this.v == '1';
    }

    allowFloor() {
        return this.s == '1';
    }

    allowTimer() {
        return this.tz == '1';
    }

    allowPrograms() {
        return this.hp == '1';
    }

    allowAddPrograms() {
        return this.programs.length < 3;
    }
    //#endregion

    //#region get
    getMode() {
        return this.m;
    }

    getOrder() {
        return this.tc;
    }

    getTemp() {
        return this.tr;
    }

    getTempMin() {
        return this.tmm;
    }

    getTempMax() {
        return this.tmx;
    }

    getHumidity() {
        return this.hm;
    }

    getFanMode() {
        return this.vv;
    }

    getTimer() {
        return this.tzv;
    }
    //#endregion

    //#region set
    setMode(heat, ac, floor) {
        let mode = null;
        if (ac && !floor) mode = 0;
        if (!ac && floor) mode = 2;
        if (ac && floor) mode = 4;

        if (!heat) mode += 1;
        this.m = `${mode}`;
    }

    setOrder(value) {
        this.tc = value;
    }

    setFanMode(value) {
        this.vv = value;
    }

    setFloor(value) {
        this.sv = value ? '1' : '0';
    }

    setTimer(value) {
        this.tzv = value;
    }

    setOutService(value) {
        this.outService = value;
    }

    setPower(value) {
        this.e = value ? '1' : '0';
    }
    //#endregion
}

export default Device;
